import React from "react";
import {
  Dumbbell,
  Brain, // for Exercise Physiologist
  HeartPulse, // for Physiotherapist
  MessagesSquare, // for Occupational Therapist
  Users,
  HandCoins,
  GraduationCap,
} from "lucide-react";

export const DAYS_OF_WEEK = [
  { value: "MON", label: "Monday" },
  { value: "TUE", label: "Tuesday" },
  { value: "WED", label: "Wednesday" },
  { value: "THU", label: "Thursday" },
  { value: "FRI", label: "Friday" },
  { value: "SAT", label: "Saturday" },
  { value: "SUN", label: "Sunday" },
];
export const getDisciplineIcon = (discipline, size = 16) => {
  const iconProps = { size: size, className: "me-2 text-primary" };
  switch (discipline) {
    case "Psychology":
    case "Psychiatry":
      return <Brain {...iconProps} />;
    case "Counseling":
      return <MessagesSquare {...iconProps} />;
    case "Social Work":
      return <Users {...iconProps} />;
    case "Physiotherapy":
      return <Dumbbell {...iconProps} />;
    case "Exercise Physiology":
      return <HeartPulse {...iconProps} />;
    case "Occupational Therapy":
      return <HandCoins {...iconProps} />;
    default:
      return <GraduationCap {...iconProps} />;
  }
};
export const inForgivenRange = (date) => {
  // // Convert input date to Date object
  // const targetDate = new Date(date);
  // const currentDate = new Date();

  // // Get the start of the current week (Monday)
  // const startOfWeek = new Date(currentDate);
  // const dayOfWeek = currentDate.getDay(); // 0 is Sunday, 1 is Monday
  // const diff = dayOfWeek === 0 ? -6 : 1 - dayOfWeek; // Adjust to get Monday
  // startOfWeek.setDate(currentDate.getDate() + diff);
  // startOfWeek.setHours(0, 0, 0, 0);

  // // Get the end of the current week (Sunday)
  // const endOfWeek = new Date(startOfWeek);
  // endOfWeek.setDate(startOfWeek.getDate() + 6);
  // endOfWeek.setHours(23, 59, 59, 999);

  // return targetDate >= startOfWeek && targetDate <= endOfWeek;
  return true;
};
export const ALLOWED_IMAGE_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/gif",
];

export const ALLOWED_VIDEO_TYPES = [
  "video/mp4",
  "video/webm",
  "video/quicktime", // mov
];
export const ADMIN_PANEL_URL =
  process.env.REACT_APP_ENVIRONMENT === "production"
    ? "/admin"
    : process.env.REACT_APP_ENVIRONMENT === "staging"
    ? "http://backend:8000/admin"
    : "https://localhost:8000/admin";

export const MAX_IMAGE_FILE_SIZE = 10 * 1024 * 1024; // 10MB
export const MAX_VIDEO_FILE_SIZE = 100 * 1024 * 1024; // 100MB
// Backwards-compatible alias for any remaining non-image media usage.
export const MAX_FILE_SIZE = MAX_VIDEO_FILE_SIZE;

export const DAY_ORDER = {
  MON: 0,
  TUE: 1,
  WED: 2,
  THU: 3,
  FRI: 4,
  SAT: 5,
  SUN: 6,
};
